module.exports = __webpack_public_path__ + "static/media/whisky_open_graph.6e8e7d99.jpg";